// extracted by mini-css-extract-plugin
export default {"cta":"oI-z","disabled":"pI-z"};